import { ISafeAreaInsets } from '../../../common/components/OfferCardPreview/components/OfferPreviewBalloon';

// Зоны карты под контролами/оверлеями - превью в них не заходит при выборе стороны.
// top = спиннер загрузки: top 24 + высота 40 (src/shared/Map/containers/Map/styles.css).
// right = колонка контролов: large-indent right 24 (Controls/Controls.css) + кнопка size M 44 (ui-kit).
// При изменении layout контролов синхронизировать значения здесь.
export const OFFER_PREVIEW_SAFE_AREA: ISafeAreaInsets = { top: 64, right: 68, bottom: 0, left: 0 };
